export default theme => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  smallRow: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  flexTableCell: {
    alignItems: 'center',
    display: 'flex'
  },
  dragging: {
    backgroundColor: theme.palette.primary.selected,
  },
  dragIcon: {
    height: '22px',
    maxHeight: '22px',
    paddingLeft: 0,
    marginRight: theme.spacing(1),
  },
  buttonLeft: {
    paddingLeft: theme.spacing(1),
    color: theme.palette.danger.main,
  },
  buttonRight: {
    float: 'right',
    paddingRight: theme.spacing(1)
  },
  largeTableCell: {
    paddingBottom: 0,
    paddingTop: 0,
    paddingRight: theme.spacing(0.5),
    paddingLeft: theme.spacing(0.5)
  },
});

